import { Upload } from '@air/redux-uploader';
import { createAction } from '@reduxjs/toolkit';

import { PublicUploadMetadata } from '~/store/publicUploadMetadata/types';

export const setPublicUploadMetadata = createAction<{ uploadId: Upload['id']; metadata: PublicUploadMetadata }>(
  'SET_PUBLIC_UPLOAD_METADATA',
);
